import React from "react";

import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnimatePresence, motion } from "framer-motion";

import { Flex } from "@chakra-ui/react";

import { Text } from "@components/Text";

interface PropTypes {
    title: React.ReactNode;
    children: React.ReactNode;
    isCollapsed: boolean;
    iconColor?: string;
    onToggleCollapse: () => void;
}

const Collapsable = ({
    title,
    isCollapsed = false,
    iconColor,
    children,
    onToggleCollapse
}: PropTypes) => {
    return (
        <Flex direction="column" gap={4}>
            <Flex
                align="center"
                gap={2}
                mr="auto"
                userSelect="none"
                cursor="pointer"
                onClick={onToggleCollapse}
            >
                <Text color="royalblue">{title}</Text>
                <AnimatePresence>
                    <motion.div
                        style={{
                            display: "flex",
                            alignItems: "center"
                        }}
                        animate={{ rotate: isCollapsed ? 180 : 0 }}
                        transition={{
                            type: "tween",
                            duration: 0.1,
                            ease: "easeOut"
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faChevronDown}
                            color={
                                iconColor ?? "var(--euka-colors-royalBlue-500)"
                            }
                            fontSize={14}
                        />
                    </motion.div>
                </AnimatePresence>
            </Flex>
            <AnimatePresence>
                {isCollapsed && (
                    <motion.div
                        style={{ overflow: "clip" }}
                        initial={{ height: 0, opacity: 0, y: -10 }}
                        animate={{ height: "auto", opacity: 1, y: 0 }}
                        exit={{ height: 0, opacity: 0, y: -1 }}
                        transition={{
                            type: "tween",
                            duration: 0.1,
                            ease: "easeOut"
                        }}
                    >
                        {children}
                    </motion.div>
                )}
            </AnimatePresence>
        </Flex>
    );
};

export default Collapsable;
